// Risoluzione robusta della BACK_URL:
// Ordine di precedenza:
// 1. process.env.VUE_APP_BACK_URL (Vue CLI / webpack)
// 2. import.meta.env.VUE_APP_BACK_URL (Vite / build modern)
// 3. window.__APP_BACK_URL__ (iniezione runtime es: index.html <script>)
// 4. fallback http://localhost:8080
const getApiUrl = () => {
  let url = undefined;

  try {
    if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_BACK_URL) {
      url = process.env.VUE_APP_BACK_URL;
    }
  } catch(err) {
    // Ignoro: ambiente senza process.env (es. browser puro)
  }

  if(!url){
    try {
      if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VUE_APP_BACK_URL) {
        url = import.meta.env.VUE_APP_BACK_URL;
      }
    } catch(err) {
      // Ignoro: import.meta non disponibile in questo toolchain
    }
  }

  if(!url){
    try {
      if (typeof window !== 'undefined' && window.__APP_BACK_URL__) {
        url = window.__APP_BACK_URL__;
      }
    } catch(err) {
      // Ignoro: window non disponibile (es. SSR)
    }
  }

  if(!url){
    url = 'http://localhost:8080';
    console.warn('[authConfig] VUE_APP_BACK_URL non trovata. Uso fallback', url);
  }

  // Normalizza rimuovendo eventuale trailing slash
  url = url.replace(/\/$/, '');
  return url;
};

const resolvedApiUrl = getApiUrl();

if(resolvedApiUrl.includes('8080')){
  console.info('[authConfig] BACK_LINK attuale =', resolvedApiUrl, ' (verifica se desideravi 8082 e riavvia il dev server se hai modificato .env)');
}

const authConfig = { 
  BACK_LINK: resolvedApiUrl,
  REFRESH_TOKEN_ROUTE: "/auth/jwt/refresh",
  ERROR_CODES_FOR_REFRESH: [401, 403],
  RESPONSE_JSON_ACC_TOKEN_KEY: "access_token",
  RESPONSE_JSON_REF_TOKEN_KEY: "refresh_token",
  LOCAL_STORAGE_ACCESS_TOKEN: "accessToken",
  LOCAL_STORAGE_REFRESH_TOKEN: "refreshToken",
  getAuthHeader: (accessToken) => {
    return {
      "Authorization": `Bearer ${accessToken}`
    }
  }
};

console.log('[authConfig] API URL risolta =', authConfig.BACK_LINK);

export default authConfig;